import { render, staticRenderFns } from "./simple.vue?vue&type=template&id=d44146da&"
import script from "./simple.vue?vue&type=script&lang=js&"
export * from "./simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d44146da')) {
      api.createRecord('d44146da', component.options)
    } else {
      api.reload('d44146da', component.options)
    }
    module.hot.accept("./simple.vue?vue&type=template&id=d44146da&", function () {
      api.rerender('d44146da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/WangEditer/simple.vue"
export default component.exports